module.exports = __webpack_public_path__ + "static/media/3DPPA28.667b9494.jpg";